/**
 * Generato automaticamente.
 * framework-cmp-procedimenti
 */
import { useMutation } from 'react-query';
import type { MutationFunction, UseMutationOptions } from 'react-query';
import { apiClientRequest } from '../../../client/apiClient';
import type { ErrorType } from '../../../client/apiClient';
import type {
  BEResponseBoolean,
  BEResponseObject,
  SendMailFromTempleteRequest,
  SendMailRequest,
} from '.././schemas';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P,
) => any
  ? P
  : never;

export const postBackUtilitySendMail = (
  sendMailRequest: SendMailRequest,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseObject>(
    {
      url: `/framework-bo-procedimenti/utility/sendMail`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: sendMailRequest,
    },
    options,
  );
};

export const getPostBackUtilitySendMailMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackUtilitySendMail>>,
    TError,
    { data: SendMailRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackUtilitySendMail>>,
  TError,
  { data: SendMailRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackUtilitySendMail>>,
    { data: SendMailRequest }
  > = props => {
    const { data } = props ?? {};

    return postBackUtilitySendMail(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackUtilitySendMailMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBackUtilitySendMail>>
>;
export type PostBackUtilitySendMailMutationBody = SendMailRequest;
export type PostBackUtilitySendMailMutationError = ErrorType<unknown>;

export const usePostBackUtilitySendMail = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackUtilitySendMail>>,
    TError,
    { data: SendMailRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions = getPostBackUtilitySendMailMutationOptions(options);

  return useMutation(mutationOptions);
};
export const postBackUtilitySendMailFromTemplete = (
  sendMailFromTempleteRequest: SendMailFromTempleteRequest,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseBoolean>(
    {
      url: `/framework-bo-procedimenti/utility/sendMailFromTemplete`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: sendMailFromTempleteRequest,
    },
    options,
  );
};

export const getPostBackUtilitySendMailFromTempleteMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackUtilitySendMailFromTemplete>>,
    TError,
    { data: SendMailFromTempleteRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackUtilitySendMailFromTemplete>>,
  TError,
  { data: SendMailFromTempleteRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackUtilitySendMailFromTemplete>>,
    { data: SendMailFromTempleteRequest }
  > = props => {
    const { data } = props ?? {};

    return postBackUtilitySendMailFromTemplete(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackUtilitySendMailFromTempleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBackUtilitySendMailFromTemplete>>
>;
export type PostBackUtilitySendMailFromTempleteMutationBody =
  SendMailFromTempleteRequest;
export type PostBackUtilitySendMailFromTempleteMutationError =
  ErrorType<unknown>;

export const usePostBackUtilitySendMailFromTemplete = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackUtilitySendMailFromTemplete>>,
    TError,
    { data: SendMailFromTempleteRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackUtilitySendMailFromTempleteMutationOptions(options);

  return useMutation(mutationOptions);
};
